module.exports = __webpack_public_path__ + "fonts/gt-america-expanded-bold.55dce71.ttf";